<template>
  <div class="all-business">
    <template v-if="list && list.items.length">
      <div style="min-height: 200px;">
        <Row :gutter="30">
          <Col span="6" v-for="(item, index) in list.items" :key="'business' + index" style="padding:10px;">
            <div class="my-info-list">
              <div class="my-info-list-t">
                <img :src="item.headImg">
                <div class="my-info-list-t-info">
                  <div>
                    <span style="font-weight:bold;color:#333">姓名 <span style="font-weight:normal;">职务</span></span><br/>
                    <span style="color:#666;">公司</span>
                    <span style="color:#666;">手机号</span>
                  </div>
                  <i class="icon iconfont icon-shoucang2" style="color:#1890ff;font-size:18px;cursor: pointer;"></i>
                </div>
              </div>
              <div class="my-info-list-m">
                <span>通过薛之谦的分享进入</span>
                <span>时间</span>
              </div>
              <div class="my-info-list-b">
                <div class="z-del">
                  <span style="color: #1890ff;">标记用户</span>
                  <span style="color: #808080;" v-if="false">取消标记</span>
                </div>
                <div class="c-line"></div>
                <div style="color:#808080;" @click="$router.push('/exhibition/index/behavior')">行为轨迹</div>
              </div>
            </div>
          </Col>
        </Row>
        <div class="my-page" v-if="totalCount > pageSize">
          <Page
            show-total
            show-elevator
            :page-size="pageSize"
            :current="pageIndex"
            :total="totalCount"
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </div>
    </template>
    <div class="u-empty" v-else>暂无数据</div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "all-business",
  data() {
    return {
      list: null,

      pageSize: 12,
      pageIndex: 1,
      totalCount: 0
    };
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany"
    }),
    option() {
      return {
        CompId: this.company.id,
        PageSize: this.pageSize,
        PageIndex: this.pageIndex
      };
    }
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getRelease: "releaseModule/getRelease",
    }),
    async init() {
      let res = await this.getRelease(this.option);
      if (res && res.items) {
        res.items.map(c => {
          if (c.photo.indexOf("[") !== -1) {
            c.photo = JSON.parse(c.photo);
          } else {
            c.photo = [];
          }
        });
      }
      this.list = res;
      if (this.list) {
        this.pageSize = this.list.pageSize;
        this.pageIndex = this.list.pageIndex;
        this.totalCount = this.list.totalCount;
      }
    },
    changePage(e) {
      this.pageIndex = e;
      this.init();
    },
    changePageSize(e) {
      this.pageSize = e;
      this.init();
    }
  }
};
</script>

<style scoped lang="scss">
.all-business {
  min-width: 1000px;
  padding: 30px;
  .my-page {
    padding-bottom: 50px;
  }
}
.my-info {
  &-list {
    width: 100%;
    margin: 0 22px 19px 0;
    background-color: #fff;
    box-shadow: 0px 0px 10px 0px rgba(53, 153, 231, 0.2);
    border-radius: 2px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    &-t {
      width: 100%;
      display: flex;
    padding: 10px 10px 0 10px;
      img {
        width: 70px;
        height: 70px;
        border-radius: 50%;
      }
      &-info {
        flex: 1;
        display: flex;
        justify-content: space-between;
        padding-left: 10px;
      }
    }
    &-m {
      width: 100%;
      padding: 10px;
      display: flex;
      justify-content: space-between;
    }
    &-b {
      display: flex;
      justify-content: space-around;
      line-height: 47px;
      background-color: #f7f9fa;
      padding: 0 20px;
      div {
        cursor: pointer;
      }
      .c-line {
        border-right: 1px solid #e8e8e8;
        height: 22px;
        margin-top: 15px;
      }
    }
  }
}
</style> 
